import { PEAD } from "../../../consts";

export function getColorForLine(name: string) {
	switch (name) {
		case PEAD.LINE.AVG:
			return PEAD.LINE_COLOR.AVG;

		case PEAD.LINE.MAX:
			return PEAD.LINE_COLOR.MAX;

		case PEAD.LINE.PRICE:
			return PEAD.LINE_COLOR.PRICE;

		case PEAD.LINE.MIN:
			return PEAD.LINE_COLOR.MIN;

		case PEAD.LINE.SIGMA_1:
		case PEAD.LINE.SIGMA_2:
		case PEAD.LINE.SIGMA_MINUS_1:
		case PEAD.LINE.SIGMA_MINUS_2:
			return PEAD.LINE_COLOR.SIGMA_1;
		default:
			return PEAD.LINE_COLOR.DEFAULT;
	}
}
